export const colorSelect = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("PT_"));
  if (headerId.startsWith("PT_")) {
    return "processPt";
  } else if (headerId.startsWith("PV_")) {
    return "processPv";
  } else if (headerId.startsWith("S_")) {
    return "site";
  } else {
    return "base";
  }
};

export const colorSelectRuturnCode = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("PT_"));
  if (headerId.startsWith("PT_")) {
    return "#09A0F2";
  } else if (headerId.startsWith("PV_")) {
    return "#FF5ECD";
  } else if (headerId.startsWith("S_")) {
    return "#ffdb5e";
  } else {
    return "#0adcc0";
  }
};

export const colorSelectRuturnCodeLite = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("PT_"));
  if (headerId.startsWith("PT_")) {
    return "#255dcd";
  } else if (headerId.startsWith("PV_")) {
    return "#d9087f";
  } else if (headerId.startsWith("S_")) {
    return " #ce8d00";
  } else {
    return "#058473";
  }
};
